import React from "react";
import MultipleExerciseComponent from "../components/MultipleExerciseComponent";

export default function ExerciseGroupComponent(props) {
    return (
        <div key={props.index}>
            {props.exercise.exercises &&
            <MultipleExerciseComponent exerciseList={props.exercise.exercises} lesetext={props.lesetext}/>}
            {/*{props.exercise.exactanswer &&*/}
            {/*<p title="exactanswer">exactanswer={props.exercise.exactanswer.toString()}</p>}*/}
        </div>
    );
}
